import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { WebUrlListPage } from '@/features/webUrls/pages/WebUrlListPage';
import { listSearchSchema } from '@/utils/listSearch';

export const Route = createFileRoute('/_auth/settings/web-urls')({
  validateSearch: listSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Web URLs">
      <Suspense fallback={<PageLoader />}>
        <WebUrlListPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
